<template>
    <div>
        aaa
    </div>
</template>

<script>
export default {
    mounted () {
        Pusher.logToConsole = true;

        var pusher = new Pusher('badf456ece97be1ac910', {
            cluster: 'eu'
        });

        var channel = pusher.subscribe('my-channel');
        channel.bind('my-event', function(data) {
            console.log(data);
            // app.messages.push(JSON.stringify(data));
        });

        // pusher.terminateUserConnections("user-id");
    },
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/PhotoTaker.vue